const formatEntry = (entry) => {
  if ((entry.type || entry.event_type) === "device_update") {
    const rooms = entry.payload?.rooms || entry.rooms || [];
    const devices = rooms.reduce((count, room) => count + (room.devices?.length || 0), 0);
    return `device_update → ${rooms.length} rooms, ${devices} devices synchronized`;
  }
  if (entry.type) return `${entry.type} → ${JSON.stringify(entry.payload || entry.data || {})}`;
  if (entry.event) return `${entry.event} → ${JSON.stringify(entry.payload || {})}`;
  if (entry.event_type) return `${entry.service || "system"} · ${entry.event_type} → ${JSON.stringify(entry.payload || {})}`;
  return JSON.stringify(entry);
};

export const LogStream = ({ events, decisions, observabilityLogs }) => (
  <section className="jarvis-panel" data-testid="log-stream-panel">
    <div className="jarvis-panel-header">
      <div>
        <p className="jarvis-eyebrow">Realtime event fabric</p>
        <h2 className="jarvis-title" data-testid="log-stream-title">Log Stream</h2>
      </div>
      <div className="jarvis-chip" data-testid="log-stream-chip">{events.length} live events</div>
    </div>
    <div className="jarvis-log-columns">
      <div className="jarvis-log-column" data-testid="live-events-column">
        <h3>Live Events</h3>
        {events.map((entry, index) => (
          <div className="jarvis-log-entry" key={`${entry.timestamp || index}-${index}`} data-testid={`live-event-${index}`}>
            {formatEntry(entry)}
          </div>
        ))}
      </div>
      <div className="jarvis-log-column" data-testid="decision-log-column">
        <h3>Decision Log</h3>
        {decisions.slice(0, 25).map((entry, index) => (
          <div className="jarvis-log-entry" key={`${entry.timestamp || index}-${index}`} data-testid={`decision-log-${index}`}>
            {formatEntry(entry)}
          </div>
        ))}
      </div>
      <div className="jarvis-log-column" data-testid="structured-log-column">
        <h3>Structured Logs</h3>
        {(observabilityLogs || []).slice(0, 25).map((entry, index) => (
          <div className="jarvis-log-entry" key={`${entry.timestamp || index}-structured-${index}`} data-testid={`structured-log-${index}`}>
            {formatEntry(entry)}
          </div>
        ))}
      </div>
    </div>
  </section>
);